export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4654.834ee151.jpg";